var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useContext, useEffect } from 'react';
import { Box, Collapse, keyframes, Stack, Typography } from '@mui/material';
import { TourContext } from "../context";
import { pxToRem } from "../../../common";
import { useTranslation } from 'react-i18next';
import { TourFeature } from "./TourFeature";
import LoadingSpinner from "../../LoadingSpinner";
var slideIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translate(-200px);\n  }\n  \n  to {\n    transform: translate(0);\n  }\n"])));
export function TourBody(_ref) {
  var isLoading = _ref.isLoading,
    tourFeatures = _ref.tourFeatures,
    _onTourStart = _ref.onTourStart,
    _onTourExit = _ref.onTourExit,
    onTourStepToggle = _ref.onTourStepToggle,
    _ref$defaultOpenFeatu = _ref.defaultOpenFeature,
    defaultOpenFeature = _ref$defaultOpenFeatu === void 0 ? null : _ref$defaultOpenFeatu;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(TourContext),
    isTourExpanded = _useContext.isTourExpanded,
    currentOpenFeature = _useContext.currentOpenFeature,
    setCurrentOpenFeature = _useContext.setCurrentOpenFeature;
  function handleOpenFeature(feature) {
    setCurrentOpenFeature(feature.id !== currentOpenFeature ? feature.id : null);
    if (onTourStepToggle) {
      onTourStepToggle({
        id: feature.id,
        isExpanded: feature.id !== currentOpenFeature
      });
    }
  }

  /**
   * If `defaultOpenFeature` is defined as a step, `Tour` will default to it being open on
   * first mount.
   */
  useEffect(function () {
    if (defaultOpenFeature !== null && defaultOpenFeature !== void 0 && defaultOpenFeature.id) {
      setCurrentOpenFeature(defaultOpenFeature.id);
    }
  }, [defaultOpenFeature]);
  return /*#__PURE__*/React.createElement(Collapse, {
    "in": isTourExpanded,
    timeout: {
      enter: 250,
      exit: 250
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      padding: '8px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: "div",
    sx: {
      mb: '8px',
      px: '10px',
      fontSize: pxToRem(16),
      fontWeight: 700
    }
  }, t('tour_body_title')), /*#__PURE__*/React.createElement(Stack, {
    spacing: 1,
    sx: [isTourExpanded && {
      animation: "250ms ".concat(slideIn)
    }]
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginInline: 'auto'
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, null)) : tourFeatures.map(function (step, i) {
    return /*#__PURE__*/React.createElement(TourFeature, _extends({
      key: i,
      isOpen: step.id === currentOpenFeature,
      onOpen: function onOpen(feature) {
        return handleOpenFeature(feature);
      },
      onTourStart: function onTourStart(s) {
        return _onTourStart(s);
      },
      onTourExit: function onTourExit(s) {
        return _onTourExit(s);
      }
    }, step));
  }))));
}